module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "news-wrap"
    }
  }, [_c('div', {
    staticClass: "news-slider-wrap"
  }, [_c('div', {
    staticClass: "news-slider-text-wrap"
  }, [_c('div', {
    staticClass: "news-slider-text",
    style: ({
      width: ((100 * _vm.$t('message.news').length) + "%"),
      transform: ("translateX(-" + ((100/_vm.$t('message.news').length) * this.index) + "%)")
    })
  }, _vm._l((_vm.$t('message.news')), function(news, index) {
    return _c('div', {
      key: index
    }, [_c('SlideNews', {
      attrs: {
        "obj": news,
        "index": index
      },
      on: {
        "toggleOpenOverlay": function($event) {
          return _vm.toggleOpenOverlay(index)
        }
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "news-slider-images-wrap"
  }, [_c('div', {
    staticClass: "news-slider-image",
    style: ({
      height: ((100 * _vm.$t('message.news').length) + "%"),
      transform: ("translateY(-" + ((100/_vm.$t('message.news').length) * this.index) + "%)")
    })
  }, _vm._l((_vm.$t('message.news')), function(news, index) {
    return _c('div', {
      key: index
    }, [_c('SlideNewsImage', {
      attrs: {
        "img": require('../../assets/images/' + news.imagesrc)
      }
    })], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "buttons-wrap",
    style: ({
      display: _vm.$t('message.news').length > 1 ? 'flex' : 'none'
    })
  }, [_c('div', {
    staticClass: "button button-prev",
    on: {
      "click": function($event) {
        return _vm.sliderBtn(-1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/arrow-prev@2x.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button button-next",
    on: {
      "click": function($event) {
        return _vm.sliderBtn(1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/arrow-next@2x.png")
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67c37405","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/News.vue
// module id = 292
// module chunks = 0